import axios from "axios";
import Config from "src/config";

const v1_actionWboTemplatesCategoryLogsNaoVistos = (clienteId) => {
    const url = `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/${clienteId}/canais/wbo/templates/logs/categoria/nao-vistos`;

    return axios({
        method: "get",
        url: url
    });
};

export default v1_actionWboTemplatesCategoryLogsNaoVistos;
